import { Modal, Button, Image } from 'antd';
import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from 'react';
import { useModel } from 'umi';
import Stat from '@/utils/stat';
import { EquityTextVMap } from './constant';
import type { ReactElement } from 'react';

import styles from './index.less';

interface EquityPackageModalPropType {
  modalType: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  modalText?: string | ReactElement; // 自定义弹窗文案
}

const EquityPackageModal = forwardRef(
  (props: EquityPackageModalPropType, ref) => {
    const [visible, setVisible] = useState(false);
    const { initialState } = useModel('@@initialState');
    const { modalType, modalText } = props;

    // 权益名称
    const equityText = useMemo(() => {
      return EquityTextVMap[modalType]?.text;
    }, [modalType]);

    // 开通功能
    const featureDesc = useMemo(() => {
      return EquityTextVMap[modalType]?.featureDesc;
    }, [modalType]);

    // 是否超管
    const isSupper = useMemo(() => {
      return initialState?.userInfo?.role === '1';
    }, [initialState?.userInfo?.role]);

    useImperativeHandle(ref, () => ({
      open: () => {
        setVisible(true);
      },
    }));

    useEffect(() => {
      if (visible) {
        Stat.track('eppc_popup_expo', {
          popup_name: `${featureDesc}拦截弹窗`,
          user_role: isSupper ? '超管' : '非超管',
          version_type: '定制品牌版',
        });
      }
    }, [visible, featureDesc, isSupper]);

    const modalContent = () => {
      if (modalText) {
        return <div className={styles['equity-text']}>{modalText}</div>;
      }
      return (
        <div className={styles['equity-text']}>
          {modalType === 2 ? (
            <>
              <span>「{featureDesc}」</span>功能已超过限制数量，
            </>
          ) : (
            <>
              如需使用<span>「{featureDesc}」</span>
              功能，
            </>
          )}
          {isSupper ? (
            <>
              请到【APP-首页/工作台-去升级】开通<span>{equityText}</span>权益。
            </>
          ) : (
            <>
              需要联系超管开通<span>{equityText}</span>权益。若有问题请咨询客服。
            </>
          )}
        </div>
      );
    };

    const handleOk = () => {
      Stat.track('eppc_popup_click', {
        popup_name: `${featureDesc}拦截弹窗`,
        user_role: isSupper ? '超管' : '非超管',
        version_type: '定制品牌版',
        button_name: '我知道了',
      });
      setVisible(false);
    };

    return (
      <Modal
        wrapClassName={styles['equity-package-modal']}
        visible={visible}
        centered={true}
        closable={false}
        width={450}
        footer={null}
      >
        <Image
          className={styles['modal-img']}
          src='https://static.huolala.cn/image/75f99ef413ff7f6cd3163b6d0e6ceb5970be3364.png'
          preview={false}
        />
        <div className={styles['modal-content']}>
          {modalContent()}
          <div className={styles['equity-btn']}>
            <Button type='primary' onClick={handleOk}>
              我知道了
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
);

export default EquityPackageModal;
